<template>
  <section>
    <h3 class="h-title">提交文件-主体文件</h3>  
    <el-form class="e-form f-b" ref="cForm2" :model="cForm2" label-width="auto"  label-position="left" :rules="setpFormRules3">
      <el-form-item class="w-70" label="三证合一" prop="threeCertOneFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'threeCertOneFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'threeCertOneFile')" 
            :on-error="handleError"
            :file-list="cForm2.threeCertOneFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="法定代表人身份证" prop="identityCardFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'identityCardFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'identityCardFile')" 
            :on-error="handleError"
            :file-list="cForm2.identityCardFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="公司简介" prop="companyProfileFile">
        <el-upload
            class="upload-part"
            :limit="1" 
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'companyProfileFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'companyProfileFile')" 
            :on-error="handleError"
            :file-list="cForm2.companyProfileFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="公司章程" prop="companyByelawFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'companyByelawFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'companyByelawFile')" 
            :on-error="handleError"
            :file-list="cForm2.companyByelawFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="高管人员简历" prop="ggPersonResumeFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'ggPersonResumeFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'ggPersonResumeFile')" 
            :on-error="handleError"
            :file-list="cForm2.ggPersonResumeFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70 label-more-r" label="近两年财务报表及近一期财务报表" prop="financeReportFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'financeReportFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'financeReportFile')" 
            :on-error="handleError"
            :file-list="cForm2.financeReportFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="灰名单查询结果" prop="riskResultFile" :rules="[{ type: 'array', required: true, message: '请上传', trigger: 'change' }]">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'riskResultFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'riskResultFile')" 
            :on-error="handleError"
            :file-list="cForm2.riskResultFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="征信报告" prop="creditReportFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'creditReportFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'creditReportFile')" 
            :on-error="handleError"
            :file-list="cForm2.creditReportFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      <el-form-item class="w-70" label="信用报告" prop="thinktankReportFile">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'thinktankReportFile')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'thinktankReportFile')" 
            :on-error="handleError"
            :file-list="cForm2.thinktankReportFile || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
      </el-form-item> 
      
    </el-form>
    <!-- 按钮 -->					
    <div class="cenrer">	
      <el-button class="s-but" type="orange" @click.native="prev">上一步</el-button>	
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>
      <el-button class="s-but" type="orange" @click.native="cSubmitForm('1')" :loading="butLoading">下一步</el-button>
    </div>
  </section>
</template>
<script>
import baseUrl from '@/api/baseUrl.js'
export default {
    name: "step2",
    props: ["active"],
		data() {
			return { 
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("token")
        },      
        cForm2: {}, 
				setpFormRules3: {
          threeCertOneFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          identityCardFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          companyProfileFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          companyByelawFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          ggPersonResumeFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
          financeReportFile: [
							{ type: 'array', required: true, message: '请上传', trigger: 'change' }
          ],
        },
        action: '',
        butLoading: false,       
        account: sessionStorage.account,
        
			}
    },
    watch: {
      active(newVal) {
        if(newVal == 2) {
          this.action = `${baseUrl.iaccUrl}/iacc-contract-platform/common/uploadFile`;
          // this.action = `http://172.30.15.232:9097/common/uploadFile`;
          this.cForm2 = JSON.parse(sessionStorage.setpForm);
          this.cForm2.threeCertOneFile = JSON.parse(this.cForm2.threeCertOneFile || '[]');
          this.cForm2.identityCardFile = JSON.parse(this.cForm2.identityCardFile || '[]');
          this.cForm2.companyProfileFile = JSON.parse(this.cForm2.companyProfileFile || '[]');
          this.cForm2.companyByelawFile = JSON.parse(this.cForm2.companyByelawFile || '[]');
          this.cForm2.ggPersonResumeFile = JSON.parse(this.cForm2.ggPersonResumeFile || '[]');
          this.cForm2.financeReportFile = JSON.parse(this.cForm2.financeReportFile || '[]');
          this.cForm2.riskResultFile = JSON.parse(this.cForm2.riskResultFile || '[]');
          this.cForm2.creditReportFile = JSON.parse(this.cForm2.creditReportFile || '[]');
          this.cForm2.thinktankReportFile = JSON.parse(this.cForm2.thinktankReportFile || '[]');
        } 
      }
    },
    methods: {  
      fontData(){
        this.cForm2.threeCertOneFile = JSON.stringify(this.cForm2.threeCertOneFile||[]);
        this.cForm2.identityCardFile = JSON.stringify(this.cForm2.identityCardFile||[]);
        this.cForm2.companyProfileFile = JSON.stringify(this.cForm2.companyProfileFile||[]);
        this.cForm2.companyByelawFile = JSON.stringify(this.cForm2.companyByelawFile||[]);
        this.cForm2.ggPersonResumeFile = JSON.stringify(this.cForm2.ggPersonResumeFile||[]);
        this.cForm2.financeReportFile = JSON.stringify(this.cForm2.financeReportFile||[]);
        this.cForm2.riskResultFile = JSON.stringify(this.cForm2.riskResultFile||[]);
        this.cForm2.creditReportFile = JSON.stringify(this.cForm2.creditReportFile||[]);
        this.cForm2.thinktankReportFile = JSON.stringify(this.cForm2.thinktankReportFile||[]);
      },
      prev() {
        this.fontData()
        sessionStorage.setpForm = JSON.stringify(this.cForm2);
        this.$emit('prev')
      },
      cSubmitForm(type) {         
        
        if(type == '0'){
          this.fontData()
          this.butLoading = true;
          this.cForm2.status = '0'
          this.$api.announcement.addAndUpd(JSON.stringify(this.cForm2)).then(response => {
            this.butLoading = false;
            if(response.code == 200){
              sessionStorage.removeItem("setpForm")
              this.$message.success("保存成功");
              this.$router.go(-1);
            }     
          });
        }else{
          // 文件必填校验
          this.$refs["cForm2"].validate((valid) => {
            if ( valid ) {  
              this.fontData()
              sessionStorage.setpForm = JSON.stringify(this.cForm2);
              this.$emit('next');                        
            }
          }) 
        }     
              
      },   
      handleError(err, file, fileList){
        this.$message.error(file.name + "文件上传失败");
      },
      beforeUpload(file) { 	
        const isLt2M = file.size / 1024 / 1024 <= 80     //这里做文件大小限制
        
        if(!isLt2M) {
          this.$message.error('上传文件大小不能超过 80MB！');
        }
        return isLt2M
      },
      upload(response, file, list, name){
          if(response.code == 200){
            this.$set(this.cForm2, name, [{
              name: response.name,
              url: response.url
            }])
            this.$refs.cForm2.clearValidate(name)
          }else{
            this.$set(this.cForm2, name,[])
            if(response.msg){
              this.$message.error(response.msg);
            }else {
              this.$message.error(file.name + "文件上传失败");
            }							
          }            
      },
      handleRemove(file, fileList, name) {
        this.$set(this.cForm2, name, [])

      },
    }
	}
</script>